package pl.zar.tikthrow.shared.dto

import kotlinx.serialization.Serializable
import pl.zar.tikthrow.shared.domain.User

@Serializable
data class RegisterRequest(val email: String, val password: String, val displayName: String)

@Serializable
data class LoginRequest(val email: String, val password: String)

@Serializable
data class AuthResponse(val token: String, val user: User)
